import { render } from "./BreadcrumbItem.vue?vue&type=template&id=7faa76b7"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__